import * as Actions from "../constants/XookConstants";

const InitialState = {
	xookId: "",
	xookLocation: "",
	isOpen: false, 	//Not being Used, kept as a reference for future Usage.
	hasActiveReplenishment: false,
	restaurantStatus: "",
	maxItemsPerOrder: 5,
	currency: "",
	pricingMap: {},
	dataLoaded: false,
	couponsLoaded: false,
	coupons: [],
	kitchenVersion: Actions.KitchenVersions.V3,
	canInstallPWA: false
};

export const Xook = (state = InitialState, action: any) => {
	switch (action.type) {
		case Actions.STORE_XOOK_DATA:
			const { description, kitchenVersion, name, ...rest } = action.data;
			return {
				...state,
				...rest,
				kitchenVersion: kitchenVersion || state.kitchenVersion,
				xookLocation: description || name || state.xookLocation,
			};

		case Actions.SET_XOOK_SERVING_DATA:
			//Handle window shopping logic here
			return {
				...state,
				hasActiveReplenishment: action.data.hasActiveReplenishment || false,
				isOpen: action.data.isOpen || false,
			};

		case Actions.SET_DATA_POLLING_ID:
			return {
				...state,
				dataPollingId: action.data,
			};

		case Actions.CLEAR_XOOK_DATA:
			return {
				...InitialState,
			};

		case Actions.SET_CURRENCY:
			return {
				...state,
				currency: action.data,
			};

		default:
			return {
				...state,
			};
	}
};

export default Xook;
